import styles from './index.module.scss';
import cx from 'classnames';
import Checkbox from '@primitives/Checkbox';
import Typography from '@primitives/Typography';
import { SelectPickerItemProps } from './interfaces';

const SelectPickerItem = ({
  selected,
  optionInfo,
  onOptionClick,
  multiSelect,
  showSourceAtBottom = false,
  customOptionTemplate,
  selectPickerItemClass
}: SelectPickerItemProps) => {
  const { label, source, isDisabled, rightAdornment, dailyLimit, hourlyLimit } = optionInfo;

  const handleClick = () => {
    onOptionClick(optionInfo);
  };

  const disableCheckboxClick = (e: React.MouseEvent<HTMLInputElement, MouseEvent>) =>
    e.stopPropagation();

  return (
    <div
      className={cx(styles['selectPicker--item'], {
        [styles['selectPicker--selected']]: selected,
        [styles['selectPicker--disabled']]: isDisabled,
        [`${selectPickerItemClass}`]:
          (dailyLimit?.callRemaining === 0 || hourlyLimit?.callRemaining === 0) && !selected
      })}
      onClick={handleClick}
    >
      <div className={styles['labelContainer']}>
        {multiSelect ? (
          <Checkbox
            title={label}
            disabled={isDisabled}
            checked={selected}
            onClick={disableCheckboxClick}
            readOnly
          />
        ) : customOptionTemplate ? (
          customOptionTemplate(optionInfo?.label, optionInfo)
        ) : (
          <Typography variant="p3">
            {label}{' '}
            {source && !showSourceAtBottom ? (
              <Typography variant="p3" as="span" className={styles.sourceText}>
                ({source})
              </Typography>
            ) : null}
          </Typography>
        )}
        {rightAdornment}
      </div>
      {showSourceAtBottom && <Typography variant="p3">{source}</Typography>}
    </div>
  );
};

export default SelectPickerItem;
